const siteConfig = {
  title: 'पारगाव ग्रामपंचायत',
  video: '/video.mp4',
  colors: {
    primary: '#1976d3',
    secondary: '#dc004e',
    navbar: '#4caf50', // New navbar color
    footer: '#00106e', // New footer color
    footerText: '#ffffff', // New footer text color
  },
  images: {
    logo: '/images/logo.png', // Example logo path
    hero: '/images/hero.jpg', // Example hero image path
  },
  fonts: {
    heading: 'Open Sans',
    body: 'Lato',
  },
  socialMedia: {
    twitter: 'https://twitter.com/maangp',
    facebook: 'https://facebook.com/maangp',
    instagram: 'https://instagram.com/maangp',
  },
  contact: {
    email: 'info@maangp.com',
    phone: '+91 1234567890',
  },
  footer: {
    title: 'पारगाव ग्रामपंचायत',
    subtext: 'पारगाव ग्रामपंचायत आपले सहर्ष स्वागत करत आहे',
    backgroundColor: '#00106e', // New footer background color
  },
  // Add more configurations as needed
};

export default siteConfig;
